<template>
  <ul class="pk10No">
    <li v-for="(item, index) in drawList" :key="index" :class="'pk10No' + item">{{ item }}</li>
  </ul>
</template>
<script>
import lotteryRandBallDF from "~/mixins/lotteryRandBallDF.mixins";
import lhcMixins from "~/mixins/lhc.mixins";
export default {
  mixins: [lotteryRandBallDF, lhcMixins],
  data() {
    return {
    };
  },
  props: {
    lottery: {
      type: [Object],
      default: null
    },
  },
}
</script>
<style lang="less">
.home-menu-component-df,.record-menu-components-df,.chart-menu-components-df  {
  .pk10No li {
    width: 38px;
    height: 38px;
    border-radius: 100%;
    margin: 20px 6px 0 0;
    font-size: 16px;
    color: #fff;
    font-weight: 500;
  }

  .pk10No {
    .pk10No01 {
      background: linear-gradient(180deg, #ffce4f, #e39e35);
      border: 1px solid #ffde9c;
      box-shadow: 0 1px 3px #d4d4d4, inset 0 -1px 2px rgba(255, 203, 203, .6)
    }

    .pk10No02 {
      background: linear-gradient(180deg, #59b8ff, #218ddd);
      border: 1px solid #a2cdff;
      box-shadow: 0 1px 3px #d4d4d4, inset 0 -1px 2px rgba(203, 249, 255, .6)
    }

    .pk10No03 {
      background: linear-gradient(180deg, #2b8ae9, #124977);
      border: 1px solid #5da9ea;
      box-shadow: 0 1px 3px #d4d4d4, inset 0 -1px 2px rgba(139, 200, 253, .6)
    }

    .pk10No04 {
      background: linear-gradient(180deg, #ffa55b, #c57a3c);
      border: 1px solid #ffb681;
      box-shadow: 0 1px 3px #d4d4d4, inset 0 -1px 2px rgba(255, 186, 129, .6)
    }

    .pk10No05 {
      background: linear-gradient(180deg, #75e5e3, #05bbb9);
      border: 1px solid #a3dcdb;
      box-shadow: 0 1px 3px #d4d4d4, inset 0 -1px 2px #d4fffe
    }

    .pk10No06 {
      background: linear-gradient(180deg, #9a9df8, #6265c2);
      border: 1px solid #c3c5ff;
      box-shadow: 0 1px 3px #d4d4d4, inset 0 -1px 2px rgba(225, 226, 255, .6)
    }

    .pk10No07 {
      background: linear-gradient(180deg, #c4c4c4, #929292);
      border: 1px solid #cacaca;
      box-shadow: 0 1px 3px #d4d4d4, inset 0 -1px 2px hsla(0, 0%, 94.5%, .6)
    }

    .pk10No08 {
      background: linear-gradient(180deg, #f7846b, #d04a4c);
      border: 1px solid #ffaaab;
      box-shadow: 0 1px 3px #d4d4d4, inset 0 -1px 2px rgba(255, 203, 203, .6)
    }

    .pk10No09 {
      background: linear-gradient(180deg, #da6561, #88302d);
      border: 1px solid #d59592;
      box-shadow: 0 1px 3px #d4d4d4, inset 0 -1px 2px rgba(255, 232, 232, .6)
    }

    .pk10No10 {
      background: linear-gradient(180deg, #7dcd8f, #3b924f);
      border: 1px solid #7fd191;
      box-shadow: 0 1px 3px #d4d4d4, inset 0 -1px 2px rgba(221, 255, 228, .6)
    }
  }

  .results .pk10No {
    display: inline-flex;
    justify-content: center;
    align-items: center
  }


}
</style>